$(function () {
	$('.jq_menu_status').change(function() {
		if (this.checked) {
			$('html, body').addClass('no-scroll');

			$(document).on('keyup', { status: this }, closeOnEscape);
		} else {
			$('html, body').removeClass('no-scroll');

			$(document).off('keyup', closeOnEscape);
		}
	});

	function closeOnEscape(event) {
		if (event.keyCode === 27) {
			var args = event.data,
				status = args.status;
			$(status).prop('checked', false).trigger('change');
		}
	}
});
